type AlgoliaSearchFiltersParams = {
  locale: string
  site?: string
  isSiteScoped: boolean
}

export function getAlgoliaSearchFilters({
  locale,
  site,
  isSiteScoped,
}: AlgoliaSearchFiltersParams): string {
  if (!isSiteScoped) {
    return `locale:${locale}`
  }

  if (!site) {
    return `locale:${locale} AND sites:__none__`
  }

  return `locale:${locale} AND (sites:"${site}" OR sites:all)`
}
